import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CardModule } from 'primeng/card';
import { MyRequestedResponsesComponent } from "../../my-requested-responses/my-requested-responses.component";

@Component({
  selector: 'app-my-requested-responses-page',
  imports: [CardModule, MyRequestedResponsesComponent],
  templateUrl: './my-requested-responses-page.component.html',
  styleUrl: './my-requested-responses-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MyRequestedResponsesPageComponent {

}
